import { useEffect } from "react";

import { ErrorBoundaryProps } from "@/src/types/generic-react-props";
import { isNotFoundError } from "@/src/utils/error/not-found-error";
import { clientLogger } from "@/src/utils/observability/client-logger";

export const useLogErrorBoundary = (
  error: ErrorBoundaryProps["error"],
  boundary: string,
): void => {
  useEffect(() => {
    // Not-found is a normal navigation outcome, not worth a log record
    if (isNotFoundError(error)) {
      return;
    }

    clientLogger.error({
      error,
      event: "react.error_boundary",
      category: "react-error-boundary",
      attributes: {
        boundary,
        "error.digest": error.digest,
      },
    });
  }, [error, boundary]);
};
